import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IStorageRepository } from '../../domain/storage';
import namedRoutes from '../../routes/named-routes';
import { AuthSignalsStateService } from '../auth/auth-store.service';
import { TemplatesSignalsStateService } from '../templates/templates-store.service';
import { WhatsappSignalsStateService } from '../whatsapp/whatsapp-store.service';
import { StoreService } from '../store.service';
import { SessionState } from './type';

@Injectable({
  providedIn: 'root',
})
export class SessionSignalsStateService extends StoreService<SessionState> {
  private storage = inject(IStorageRepository);
  private router = inject(Router);
  private authStore = inject(AuthSignalsStateService);
  private templatesStore = inject(TemplatesSignalsStateService);
  private whatsappStore = inject(WhatsappSignalsStateService);

  private isLoggingOut = false;

  protected getInitialState(): SessionState {
    return {
      token: '',
      isLogged: false,
      userId: '',
    };
  }

  public async logout(redirect = true) {
    if (this.isLoggingOut) {
      return;
    }

    this.isLoggingOut = true;

    this.clearAllStores();

    try {
      if (redirect) {
        await this.router.navigate([namedRoutes.auth.signIn], { replaceUrl: true });
      }
    } finally {
      this.isLoggingOut = false;
    }
  }

  public clearAllStores(): void {
    this.whatsappStore.disconnectEvents();
    this.clear();
    this.authStore.clear();
    this.templatesStore.clear();
    this.whatsappStore.clear();
    this.storage.clearAll();
  }
}
